<template>
	<div>
		<div class="container">
			<div class="row content">
				<div class="col-12 toolbar">
					<SelectWrapper class="mb-2">
						<multiselect :multiple="false" track-by="id" label="name" v-model="selectedManager"
						:options="managerList" placeholder="Select Manager" tagPosition="below"></multiselect>
					</SelectWrapper>
          <SelectWrapper class="mb-2">
						<multiselect :multiple="true" track-by="id" label="name" v-model="user_ids"
						:options="userList" placeholder="Select Employees">
						</multiselect>
					</SelectWrapper>
          <SelectWrapper class="mb-2">
            <multiselect  v-model="project_ids" @search-change="populateSuggestions"
              :searchable="true" :placeholder="`Type to search project`" label="name"
              track-by="id" :options="projects ? projects : []" :multiple="true" :taggable="true" :limit="4">
            </multiselect>
          </SelectWrapper>
          <SelectWrapper class="mb-2">
						<multiselect :multiple="true" track-by="id" label="name" v-model="city_ids"
						:options="cityList" placeholder="Select Cities">
						</multiselect>
					</SelectWrapper>

					<div class="range-wrapper mt-2">
						<div class="inner-wrapper">
							<button :class="{'active': toggle_date === 7}"  @click="toggleDate('7')"  type="button">7 days</button>
							<button :class="{'active': toggle_date === 15}" @click="toggleDate('15')"  type="button">15 days</button>
						</div>
						<date-picker :clearable="true" :disabled-date="disableDates" v-model="start_date" placeholder="Custom Date"></date-picker>
						<date-picker :clearable="true" :disabled-date="disableDates" v-model="end_date" placeholder="Custom Date"></date-picker>
					</div>
					<div class="range-wrapper mt-2">
						<date-picker
							v-model="updateFrom"
							format="YYYY-MM-DD"
							placeholder="Updated At From"
							:disabled-date="disableDates"
						/>
						<date-picker
							v-model="updateUpto"
							format="YYYY-MM-DD"
							placeholder="Updated At Upto"
							:disabled-date="disableDates"
						/>
					</div>
          <div class="range-wrapper mt-2">
            <button type="button" class="btn-reset" @click="resetAll" >Reset</button>
            <button type="button" class="btn-apply" @click="getReport" >Apply</button>
          </div>
				</div>
			</div>
			<div class="row">
			<div class="col-12 px-10 mt-4 pt-2">
				<BarChart :graphData="pipeLineGraphData" v-if="pipeLineGraphData && isShowBarchart"/>
				<LineChart :graphData="pipeLineGraphData" v-if="pipeLineGraphData && !isShowBarchart"/>
			</div>
		</div>
			<div class="row mb-60">
				<div class="col-12 px-10 mt-3">
					<div v-if="pipeLineData && pipeLineData?.length > 0">
					<div v-for="user in pipeLineData" class="employee-card" :key="user?.user_id">
						<div class="top-section">
							<div>
								<div class="name">{{user?.full_name}}</div>
								<div class="leads-count" @click="user?.total_leads && openDetails('leads', user?.user_id)"><span>{{user?.total_leads}}</span> Total lead{{user?.total_leads > 1 ? 's' : ''}}</div>
							</div>
						</div>
						<div class="bottom-section">
							<div>
								<div class="title">Pipeline Amount</div>
								<div class="value">{{user?.pipeline_amount}}</div>
							</div>
	
							<div>
								<div class="title">Pipeline leads</div>
								<div class="value" @click="user?.pipeline_leads_count &&  openDetails('pipeline',user?.user_id)">{{user?.pipeline_leads_count}}</div>
							</div>
	
							<svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M8.41895 12H24.2666M24.2666 12L18.3237 6M24.2666 12L18.3237 18" stroke="#07B148" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								<circle cx="4.82864" cy="12" r="1.11429" fill="#07B148"/>
								<circle cx="1.85696" cy="12" r="1.11429" fill="#07B148"/>
							</svg>
	
	
							<div>
								<div class="title">Site visit leads</div>
								<div class="value" @click="user?.pipeline_visits_count && openDetails('visit',user?.user_id)">{{user?.pipeline_visits_count}}</div>
							</div>
						</div>
					</div>
					</div>
					<!-- card ends here -->
				</div>
			</div>

		</div>
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';
import SelectWrapper from '@/components/Common/SelectWrapper.vue';
import 'vue2-datepicker/index.css';
import LineChart from '@/components/Common/LineChart.vue';
import BarChart from '@/components/Common/BarChart.vue';
export default {
	created() {
		this.$store.dispatch('setActiveTitle', "Pipeline Report");
     this.$store.dispatch('setLoading', true);
	},
	components: {
		Multiselect,
		DatePicker,
		SelectWrapper,
		LineChart,
		BarChart
	},
  async beforeCreate(){
    await this.$axios.get("/settings")
      .then(res => {
        let {cities, managers, accessible_users, star_projects} = res.data
          this.managerList = managers;
          this.cityList = cities;
          this.userList = accessible_users;
          this.project_ids = star_projects;
					this.projects = star_projects;
					this.staredProjects = star_projects;
        })
      .catch(err => console.log(err));
      await this.$axios.get('/pipeline_report', {
        params: {
         ...this.payload
        }
      }).then(res => {
        if(res.data){
          this.pipeLineData = res.data?.data;
          this.pipeLineGraphData = res.data?.graph_data;
        }
        }).catch(err => { })
  },
	data() {
		return {
			start_date:new Date(new Date().setDate(new Date().getDate() - 7)),
			end_date:new Date(),
			selectedManager: [],
      user_ids: [],
			project_ids: [],
      city_ids: [],
			projects: [],
			managerList: [],
      userList: [],
      cityList: [],
      toggle_date: 7,
      pipeLineData: [],
      pipeLineGraphData: [],
			staredProjects:[],
			updateFrom:null,
			updateUpto:null,
			isShowBarchart:false
		}
	},
  methods:{
		disableDates(date) {
      const today = this.$moment();
      const sixMonthsAgo = this.$moment().subtract(6, 'months');
      return date < sixMonthsAgo.toDate() || date > today.toDate();
    },
    populateSuggestions(event){
        if(event.length === 3){
          let url = `/projects?input_str=${event.trim()}`
          this.$axios.get(url)
            .then(res => {
              if(res.data.projects.length > 0){
                this.projects = res.data.projects
              }
            })
            .catch(err => {
            })
        }
    },
    limitText (count) {
      return `+ ${count} more`
    },
    getReport(){
			if (!this.updateFrom && !this.updateUpto) {
				if (!this.start_date && !this.end_date) {
					this.start_date = new Date(new Date().setDate(new Date().getDate() - 7));
					this.end_date = new Date();
				} else if (!this.start_date && this.end_date) {
					this.start_date = new Date(new Date(this.end_date).setDate(new Date(this.end_date).getDate() - 7));
				} else if (this.start_date && !this.end_date) {
					this.end_date = new Date(new Date(this.start_date).setDate(new Date(this.start_date).getDate() + 7));
				}
				this.isShowBarchart = false;
			}else{
				this.isShowBarchart = true;
			}
      this.$axios.get('/pipeline_report', {
        params: {
          ...this.payload
        }
      })
        .then(res => {
					if (res?.data?.message) {
						this.$bvToast.toast(res.data.message, {
							title: 'Message',
							variant: 'danger',
							toaster: 'b-toaster-top-full',
							solid: true
        		})
						this.toggle_date = "";
						this.pipeLineData = [];
						this.pipeLineGraphData = [];
					}else{
            this.pipeLineData = res.data?.data;
            this.pipeLineGraphData = res.data?.graph_data;
						this.$store.dispatch('setLoading', false);
						this.toggle_date = this.selectedDayCount();
          }
          
        })
        .catch(err => {
        })
    },
    resetAll(){
			this.start_date = new Date(new Date().setDate(new Date().getDate() - 7));
			this.end_date = new Date();
      this.project_ids = this.staredProjects;
      this.user_ids = [];
      this.selectedManager = '';
      this.city_ids = [];
      this.toggle_date = 7;
			this.updateFrom = null;
			this.updateUpto = null;
			this.$nextTick(() => {
				this.getReport();
			});
    },
		openDetails(type, userId) {
			let otherParams = ""
			if (type === 'pipeline') {
				otherParams = {
					pipeline_leads: true,
					type:'Pipeline leads'
				}
			} else if (type === 'visit') {
				otherParams = {
					pipeline_leads: true,
					visited: true,
					type:'Site visit leads'
				}
			}
			const url = this.$router.resolve({
				path: '/leads/for/pipeline',
				query: {
					...this.payload,
					...otherParams,
					user_id: userId,
					hide_test: true
				}
			}).href;

			window.open(url, '_blank');
		},
		toggleDate(days){
      if (days === '7') {
				this.toggle_date = 7;
				this.start_date = new Date(new Date().setDate(new Date().getDate() - 7));
				this.end_date = new Date();
			}else{
				this.toggle_date = 15;
				this.start_date = new Date(new Date().setDate(new Date().getDate() - 15));
				this.end_date = new Date();
			}
		},
		selectedDayCount() {
      if (!this.start_date && !this.end_date) return null;
				const startDate = this.$moment(this.start_date).startOf('day');
				const endDate = this.$moment(this.end_date).startOf('day');
				const today = this.$moment().startOf('day');
				const expectedStart7 = today.clone().subtract(7, 'days');
				const expectedStart15 = today.clone().subtract(15, 'days');
				if (endDate.isSame(today)) {
					if (startDate.isSame(expectedStart7)) {
						return 7;
					} else if (startDate.isSame(expectedStart15)) {
						return 15;
					}
				}
      return null;
    }
  },
  computed:{
    payload(){
      return {
				...(this.start_date ? {start_date: this.$moment(this.start_date).format('YYYY-MM-DD') } : {}),
				...(this.end_date ? {end_date: this.$moment(this.end_date).format('YYYY-MM-DD') } : {}),
        project_ids: this.project_ids?.map(p => p.id),
        user_ids: this.user_ids?.map(u => u.id),
        manager_ids: this.selectedManager?.id,
        city_ids: this.city_ids?.map(c => c.id),
         ...(this.updateFrom ? {history_updated_at_from: this.$moment(this.updateFrom).format('YYYY-MM-DD') } : {}),
         ...(this.updateUpto ? {history_updated_at_upto: this.$moment(this.updateUpto).format('YYYY-MM-DD') } : {}),
      }
    }
  },
	watch:{
		toggle_date(newVal,oldVal){
      if (newVal) {
				this.getReport();
			}
		},
	}
}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.px-10 {
		padding-left: 10px;
		padding-right: 10px;
	}
	.content {
		margin-top: 60px;
		padding-top: 4px;
	}

  .mb-60{
    margin-bottom: 60px;
  }

	.toolbar {
		background-color: #fff;
		padding: 10px;
	}

	.employee-card {
		background-color: #fff;
		border-radius: 6px;
		box-shadow: 0px 2px 4px 0px #0000000D;
		border: 1px solid #DFDFDF;
		margin-bottom: 16px;
	}

	.btn-fav {
		background-color: transparent;
		border: 1px solid rgba(51, 51, 51, 0.1);
		border-radius: 5px;
		padding: 4px;
		cursor: pointer;
		line-height: 1;
		display: inline-flex;
	}

	.employee-card .top-section, .employee-card .bottom-section {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		padding: 10px;
	}
	
	.employee-card .top-section{
		border-bottom: 1px solid #EEEEEE;
	}

	.employee-card .bottom-section .title{
		font-weight: 500;
		font-size: 8px;
		line-height: 10px;
		letter-spacing: 0.6px;
		text-transform: uppercase;
		margin-bottom: 4px;
	}

	.employee-card .bottom-section .value{
		font-weight: 700;
		font-size: 16px;
		line-height: 19px;
		color: #539FBB;
	}

	.employee-card .name {
		font-size: 15px;
		font-weight: 500;
		color: #333333;
		margin-bottom: 4px;
	}

	.employee-card .leads-count {
		font-size: 12px;
		color: rgba(51, 51, 51, 0.5);
    display: inline-flex;
    align-items: center;
    gap: 4px;
	}

	.employee-card .leads-count span {
		font-weight: 600;
		color: #333333;
	}

	.employee-card .leads-count::before{
		content: '';
		display: inline-block;
		width: 4px;
		height: 4px;
		background-color: #07B148;
		border-radius: 50%;
		box-shadow: 0px 0px 6px 2px rgba(54, 241, 61, 0.25);
	}

	.range-wrapper {
		display: flex;
		align-items: center;
		gap: 8px;
	}
	.range-wrapper .inner-wrapper {
		border-radius: 5px;
		box-shadow: 0px 4px 4px 0px #0000000D inset;
		display: flex;
		align-items: center;
		background-color: #F4F4F4;
		padding: 2px;
	}
	.range-wrapper button {
		background-color: transparent;
		border: 1px solid transparent;
		border-radius: 4px;
		padding: 6px 12px;
		cursor: pointer;
		font-weight: 600;
		font-size: 14px;
		line-height: 16px;
		text-align: center;
		color: rgba(51, 51, 51, 0.5);
		transition: all 0.3s ease;
	}
	.range-wrapper button.active {
		background-color: #fff;
		color: #fff;
		border-color: #fff;
		color: #37A9D4;
		font-weight: 600;
		box-shadow: 0px 1px 2px 0px #00000026;

	}

	.btn-view-saved{
		display: inline-flex;
		align-items: center;
		gap: 6px;
		padding: 8px;
		border-radius: 6px;
		box-shadow: 0px 2px 4px 0px #0000000D;
		border: 1px solid #DFDFDF;
		font-weight: 400;
		font-size: 14px;
		line-height: 16px;
		color: #999999;
		background-color: #FFFFFF;
	}

  .btn-apply{
    background-color: #539FBB !important;
    color: #FFFFFF !important;
    border-radius: 6px;
    border: transparent;
    padding: 8px !important;
    flex-grow: 1;
    box-shadow: 0px 2px 4px 0px #0000000D !important;
  }

  .btn-reset{
    border: 1px solid #DFDFDF !important;
    border-radius: 6px;
    padding: 8px !important;
    flex-grow: 1;
    box-shadow: 0px 2px 4px 0px #0000000D !important;
  }
</style>
